import React from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import lazyLoad from 'utils/lazyLoad';
import RedirectWithToast from 'components/RedirectWithToast';
import { FormattedMessage } from 'react-intl';
import { getIsStakeholderUser } from 'selectors/loggedInUser';
import useFeatureToggle from 'hooks/useFeatureToggle';
import { getRouterPath } from 'utils/navigation';
import { hasViewMessagingList } from 'selectors/permissions';

const MessagingListPage = lazyLoad(
  () =>
    import(
      /* webpackChunkName: "MessagingListPage" */ 'pages/MessagingListPage'
    ),
);

const UnauthorizedPageAccess = lazyLoad(
  () =>
    import(
      /* webpackChunkName: "UnauthorizedPageAccess" */ 'pages/UnauthorizedPageAccess'
    ),
);

export default function useMessagingRoutes() {
  const canViewMessagingList = useSelector(hasViewMessagingList);
  const isLoggedInUserStakeholder = useSelector(getIsStakeholderUser);
  const isStakeholderUsersEnabled = useFeatureToggle(
    'ENABLE_STAKEHOLDER_USERS',
  );

  return [
    <Route
      path={getRouterPath('/MessagingList')}
      component={
        canViewMessagingList ? MessagingListPage : UnauthorizedPageAccess
      }
    />,
    isStakeholderUsersEnabled && isLoggedInUserStakeholder && (
      <Route
        path={[
          getRouterPath('/PanelSectionsPlace:(.*)?'),
          getRouterPath('/ChooseRebScenarioPlace:(.*)?'),
        ]}
      >
        <RedirectWithToast
          to="/MessagingList"
          message={
            <FormattedMessage id="STAKEHOLDER_UNABLE_TO_SEND_MESSAGES" />
          }
          type="warning"
        />
      </Route>
    ),
  ];
}
